module.exports = __webpack_public_path__ + "open-sans-latin-300.10dbc03f6171f566d4eb.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-300.woff2
// module id = ../../../../typeface-open-sans/files/open-sans-latin-300.woff2
// module chunks = 1 3